import React from 'react';
import Button from 'react-bootstrap/Button';
import { BsCreditCard } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { cardBackgroundColor, cardHeight } from './payment-card-list-item';

const backgroundColor = cardBackgroundColor;

function PaymentCardNew({ onClick, disabled }) {
  // const [cvc, setCVC] = useState();
  const classes = useStyles();
  // const inputRef = useRef();

  // const handleOnCVCChange = (event) => {
  //   const { value } = event.target;
  //   setCVC(value);
  // };

  return (
    <div className={classes.container}>
      <Button
        style={{
          backgroundColor,
          //   '--animate-delay': containerDelay(),
        }}
        className={classes.button}
        size="md"
        onClick={disabled ? null : onClick}
      >
        <div className={classes.content}>
          <BsCreditCard className={classes.icon} />
          Outro cartão
        </div>
      </Button>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: -layoutDefaults.smallVerticalMargin,
  },
  button: {
    width: '100%',
    minHeight: cardHeight,
    textAlign: 'left',
    paddingLeft: layoutDefaults.horizontalMargin,

    // border: '1px solid red',
  },
  content: {
    width: '100%',
    marginLeft:
      layoutDefaults.horizontalMargin - layoutDefaults.smallerHorizontalMargin,
    // paddingRight: layoutDefaults.horizontalMargin,

    // border: '1px solid red',
  },
  icon: {
    opacity: layoutDefaults.opacity,
    marginRight:
      layoutDefaults.bigHorizontalMargin -
      layoutDefaults.smallerHorizontalMargin,
  },
});

export { PaymentCardNew };
